import React, { FunctionComponent } from 'react';
import { makeStyles } from '@rbx/ui';
import StandardMarkdown, { StandardMarkdownProps } from './StandardMarkdown';

const useStyles = makeStyles()({
  container: {
    '& :last-child': {
      marginBottom: 0,
    },
  },
});

interface StandardMarkdownNoMarginProps extends StandardMarkdownProps {
  className?: string;
}

const StandardMarkdownNoMargin: FunctionComponent<
  React.PropsWithChildren<StandardMarkdownNoMarginProps>
> = ({ children, className, inlineCodeProps, paragraphProps }) => {
  const {
    classes: { container },
    cx,
  } = useStyles();

  return (
    <div className={cx(container, className)}>
      <StandardMarkdown paragraphProps={paragraphProps} inlineCodeProps={inlineCodeProps}>
        {children}
      </StandardMarkdown>
    </div>
  );
};

export default StandardMarkdownNoMargin;
